// extracted by mini-css-extract-plugin
export default {"loader__container":"ev_ew","loader":"ev_bc","loader-spin":"ev_ex","loader__content":"ev_ey"};